<template>
  <div>
    <div class="so-combos-toolbar">
      <app-button
        :label="t('Adicionar combo')"
        icon="pi pi-plus"
        size="small"
        no-explanation="abre o formulário do catálogo, sem efeito até salvar"
        data-testid="so-combos-add-btn"
        @click="handleNew"
      />
    </div>

    <s-o-combos-table ref="tableRef" @edit="handleEdit" />

    <!-- SOCombosModal é centralizado no ModalManager.vue -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import SOCombosTable from './SOCombosTable.vue';

const { t } = useI18n();

const tableRef = ref<{ loadData: () => void } | null>(null);

const handleNew = (): void => {
  eventBus.emit('modal.so-combos.open', {});
};

const handleEdit = (id: number): void => {
  eventBus.emit('modal.so-combos.open', { id });
};

const onSaved = (): void => tableRef.value?.loadData();

onMounted(() => {
  eventBus.on('so-combos.saved', onSaved);
});

onBeforeUnmount(() => {
  eventBus.off('so-combos.saved', onSaved);
});
</script>

<style scoped>
.so-combos-toolbar {
  margin-bottom: 20px;
}
</style>
